import React from "react";
import StyledCtaText from "../../../common/components/styledCtaText/StyledCtaText";

const GradientButton = ({ onClick, children, fontColor, disabled }) => {
  return (
    <button
      type="button"
      onClick={disabled ? null : onClick}  
      disabled={disabled}
      className={`${
        disabled ? "cursor-not-allowed opacity-50" : "hover:shadow-lg"
      } ${fontColor} text-black gradientButton w-fit rounded-md px-3 py-2 shadow-gray-900/10 transition-all`}
    >
      <StyledCtaText>{children}</StyledCtaText>
    </button>
  );
};
export default GradientButton;
